import React from 'react';

import * as S from './styles';

const Footer: React.FC = ({ children, ...rest }) => {
  return <S.Footer {...rest}>{children}</S.Footer>;
};

export default Footer;
